<template>
  <div>
    <div class="infoListBox">
      <div v-for="item in items" :key="item.ID" class="infoItem clearfix" v-on:click="showDetail(item.ID)">
        <div class="fl imgBox">
          <img :key="item.Att.AttID" :src="item.Att.Url" alt/>
        </div>
        <div class="fl infoBox">
          <div class="title">{{item.Title}}</div>
          <div class="desc" v-html="item.Content"></div>
          <div class="date">{{item.PublishTime}}</div>
        </div>
      </div>
    </div>
    <!--
    <div class="row mt10" style="margin-left: 0; margin-top: 10px;">
      <el-pagination
        @current-change="loadMore"
        background
        :page-size="search.PageSize"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    -->
  </div>
</template>
<script>
import api from "../../api";
export default {
  data() {
    return {
      showLoading: false,
      items: [],
      total: 0,
      search: {
        PageNo: 1,
        PageSize: 20,
        typeId: 1
      }
    };
  },
  methods: {
    showDetail(id) {
      this.$router.push("/companydynamic/detail?id=" + id);
    },
    loadMore(n) {
      this.search.PageNo = n;
      this.loadItems();
    },
    reload() {
      this.search.PageNo = 1;
      this.loadItems();
    },
    loadItems() {
      let _this = this;
      _this.showLoading = true;
      _this.items = [
      {ID:1,Title:'司机评分公示（全部）',Content:'嘉盈智慧物流秉承对实际承运人公平公正的信用评价体系，围绕运输效率、运输安全、服务质量等进行综合考核评价，将2021年3月份评价结果在平台公示：',PublishTime:'2021-04-01 10:12:34',Att:{AttID:1,Url:'/static/images/pingjia.png'}},
      
      ]
    }
  },
  mounted() {
    this.loadItems();
  }
};
</script>
<style>
.infoListBox {
  width: 1200px;
  margin: -10px auto 40px;
}
.infoListBox {
  width: 1200px;
  margin: -10px auto 40px;
}
.infoListBox .infoItem {
  padding-bottom: 20px;
  border-bottom: 1px solid #cccccc;
  margin-bottom: 18px;
}
.infoListBox .infoItem .imgBox {
  width: 220px;
  height: 140px;
  overflow: hidden;
  margin-right: 20px;
  float: left;
}
.infoListBox .infoItem .infoBox {
  width: 950px;
}
.infoListBox .infoItem .infoBox .title {
  font-size: 24px;
  line-height: 24px;
  margin-bottom: 15px;
}
.infoListBox .infoItem .infoBox .desc {
  font-size: 16px;
  line-height: 28px;
  color: #999999;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  height: 84px;
}
.infoListBox .infoItem .infoBox .date {
  font-size: 14px;
  line-height: 14px;
  color: #999999;
}
.imgBox img {
  vertical-align: top;
  width: 100%;
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/pages/CompanyDynamic/List.vue